export default {
    init() {
        this.registrationUpload();
       this.registrationDragAndDropUpload();
       this.registrationDeleteUploadFromList();
       this.registrationDragFromList();
       this.verificationForm();
    },

    registrationUpload(){
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let maxAllowedSize = 16 * 1024 * 1024;
        let wrongFile = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-row .wrong-file-type');
        let uploadArea = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-box');
        let filesList = $('.fr-registration.pop-up .product-photo-upload-wrap--list');
        let importFileInput = $('.fr-registration.pop-up .product-img-file');

        importFileInput.on('change', function () {
            if ($(this)[0].files.length > 0) {
                uploadArea.removeClass('invalid');
                let filesAllowed = [];
                let countInvalid = false;
                let files = $(this)[0].files;

                for (let i = 0; i < files.length; i++) {
                    if(files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else{
                        countInvalid = true;
                    }
                }

                for (let i = 0; i < filesAllowed.length; i++ ) {
                    let numberOfChildren = filesList.children().length;
                    if(numberOfChildren < 30) {
                        filesList.append(`
                        <li class="item">${filesAllowed[i].name}<span data-name="${filesAllowed[i].name}"></span></li>
                    `);
                    }
                }

                if(countInvalid == true ){
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }
            }
        });
    },

    registrationDragAndDropUpload() {
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let maxAllowedSize = 16 * 1024 * 1024;
        let wrongFile = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-row .wrong-file-type');
        let uploadArea = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-box');
        let filesList = $('.fr-registration.pop-up .product-photo-upload-wrap--list');
        let explorerCheck = false;
        let safariCheck = false;

        if (navigator.userAgent.indexOf('Trident/') !== -1) {
            explorerCheck = true;
        } else {
            explorerCheck = false;
        }

        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            safariCheck = true;
        } else {
            safariCheck = false;
        }

        if (!safariCheck && !explorerCheck) {
            // Drag and drop
            window.addEventListener('dragenter', preventDefaults, false);
            window.addEventListener('dragleave', preventDefaults, false);
            window.addEventListener('dragover', preventDefaults, false);
            window.addEventListener('drop', preventDefaults, false);

            window.addEventListener('dragover', highlight, false);
            window.addEventListener('drop', dropFiles, false);
        } else {
        }

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        function highlight() {
            $('.drag-and-drop-toggle.pop-up').show();
        }

        function dropFiles(e) {
            $('.drag-and-drop-toggle.pop-up').hide();

            //If delete previous import
            //filesList.empty();

            let filesAllowed = [];
            let files = e.dataTransfer.files;
            let countInvalid = false;

            for (let i = 0; i < files.length; i++) {
                if(files[i].size < maxAllowedSize) {
                    let extension = files[i].name.split('.').pop().toLowerCase();
                    let isSuccess = fileTypes.indexOf(extension) > -1;
                    if (isSuccess) {
                        filesAllowed.push(files[i]);
                    } else {
                        countInvalid = true;
                    }
                } else{
                    countInvalid = true;
                }
            }

            if(countInvalid == true ){
                uploadArea.addClass('invalid');
                wrongFile.slideDown(300);
            } else {
                wrongFile.slideUp(300);
                uploadArea.removeClass('invalid');
            }

            generateFileList(filesAllowed);
            document.querySelector('.fr-registration.pop-up .product-img-file').files = new FileListItem(filesAllowed);
        }

        function generateFileList(files) {
            for (let file of files) {
                let numberOfChildren = filesList.children().length;
                if(numberOfChildren < 30) {
                    filesList.append(`<div class="item">"${file.name}" <span data-name="${file.name}"></span></div>`);
                }
            }
        }

        function FileListItem(a) {
            a = [].slice.call(Array.isArray(a) ? a : arguments)
            for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
            if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
            for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
            return b.files
        }
    },

    registrationDeleteUploadFromList() {
        $('body').on('click', '.fr-registration.pop-up .product-photo-upload-wrap--list .item span' ,function () {
            $(this).parent().remove();
        });
    },

    registrationDragFromList() {
        $('.fr-registration.pop-up .product-photo-upload-wrap--list .item').droppable({
            cursor: 'move',
            greedy: true,
            connectToSortable: ".fr-registration.pop-up .product-photo-upload-wrap--list",
        });
        $('.fr-registration.pop-up .product-photo-upload-wrap--list').sortable({
            revert: true,
        });
    },

    verificationForm(){
        function validateEmail(elementValue1) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(elementValue1)
        }

        let validateNumbers = function (elementValue2) {
            return /^[-+]?[0-9]+$/.test(elementValue2);
        };

        $(document).on('submit', '.cl-log-in--form', function (e) {
            e.preventDefault();
            
            let loader = $('.loader-holder');
            let errorMsg = $('.cl-log-in--form .error-message');
            // let successMsg = $('.account-edit-form .success-message');
            errorMsg.hide();
            // successMsg.hide();
            loader.show();
            let validation = true;
            let inputsEmail = $('.cl-log-in--form .form-email');
            let inputsPhone = $('.cl-log-in--form .form-phone');
            let newPassword = $('.cl-log-in--form .new-password');
            let newRepeatPassword = $('.cl-log-in--form .repeat-new-password');

            $(".form-input.mandatory", this).each(function () {
                let element = $(this);
                if($(this).attr('type') == 'checkbox'){
                    if (element.is(":checked") == false) {
                        element.closest('.form-checkbox').addClass('input-invalid');
                        validation = false;
                    } else {
                        element.closest('.form-checkbox').removeClass('input-invalid');
                    }
                } else {
                    if (element.val() === "") {
                        element.closest('.form-item').addClass('input-invalid');
                        validation = false;
                    } else {
                        element.closest('.form-item').removeClass('input-invalid');
                    }
                }
            });
            if(inputsEmail.length > 0) {
                inputsEmail.each(function(){
                    let value = $(this).val();
                    let valid = validateEmail(value);
                    if (!valid && value.length > 0) {
                        $(this).closest('.form-item').addClass('input-invalid');
                        validation = false;
                    } else {
                        $(this).closest('.form-item').removeClass('input-invalid');
                    }
                });
            }
            if(inputsPhone.length > 0) {
                inputsPhone.each(function(){
                    let value2 = $(this).val();
                    let valid2 = validateNumbers(value2);
                    if (!valid2 && value2.length > 0) {
                        $(this).closest('.form-item').addClass('input-invalid');
                        validation = false;
                    } else {
                        $(this).closest('.form-item').removeClass('input-invalid');
                    }
                });
            }
            if(newPassword.val() == newRepeatPassword.val()){
                newPassword.closest('.form-item').removeClass('input-invalid');
                newRepeatPassword.closest('.form-item').removeClass('input-invalid');
            } else {
                validation = false;
                newPassword.closest('.form-item').addClass('input-invalid');
                newRepeatPassword.closest('.form-item').addClass('input-invalid');
            }
            if (validation == true) {
                e.currentTarget.submit();
                // let formData = new FormData( $("#account-edit-form")[0] );
                // formData.append('account-edit-form','1');

                // $.ajax({
                //     type: "POST",
                //     enctype: 'multipart/form-data',
                //     url: "/user-profile",
                //     data: formData,
                //     processData: false,
                //     contentType: false,
                //     success: function (resp) {
                //         //successMsg.slideDown(300);
                //     }
                // });
            } else {
                errorMsg.slideDown(300);
            }

            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });
    },

}
